import { State } from '@progress/kendo-data-query';

export const DEFAULT_DATA_STATE: State = {
  filter: {
    logic: 'and',
    filters: [],
  },
};
export const SERIAL_NUMBER_FIELD = 'serialNumber';
export const DATA_ITEM_KEY = 'id';
export const SELECTED_FIELD = 'isSelected';
export const ROW_HEIGHT = 46;
export const PANELS_HEIGHT = 92;
export const PAGE_SIZE = 20;
